import { http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { LocationQuery } from 'vue-router';
import { ImportedEmploymentsCustomer } from './imported-employments-customer.interface';

export class ImportedEmploymentsCustomerService {
   async getImportedEmploymentsCustomers(params?: LocationQuery) {
      const response = await http.get<ApiResource<Array<ImportedEmploymentsCustomer>>>(`/imported-employment-customers`, { params });
      return response.data;
   }

   async getImportedEmploymentsCustomer() {
      throw Error('Method not implemented');
   }

   async postImportedEmploymentsCustomer() {
      throw Error('Method not implemented');
   }

   async putImportedEmploymentsCustomer() {
      throw Error('Method not implemented');
   }

   async deleteImportedEmploymentsCustomer() {
      throw Error('Method not implemented');
   }
}
